/** Keep login redirects on this workspace; never accept external URLs. */
export function safeReturnTo(value: unknown): string | null {
  if (typeof value !== "string" || !value.startsWith("/") || value.startsWith("//")
      || /[\\\u0000-\u0020]/.test(value)) return null;
  try {
    const url = new URL(value, "https://workspace.coprint.in");
    if (url.origin !== "https://workspace.coprint.in" || /^\/(login|onboarding)\/?$/.test(url.pathname)) return null;
    return url.pathname + url.search + url.hash;
  } catch { return null; }
}

export function loginDestination(search: string, state?: unknown): string {
  const query = new URLSearchParams(search).get("returnTo");
  const legacy = state && typeof state === "object" && "from" in state ? state.from : null;
  return safeReturnTo(query) ?? safeReturnTo(legacy) ?? "/";
}
